import { navigate } from 'gatsby'
import React from 'react'

import icon_1 from '../../../assets/images/icon-1.png'
import img_tarjeta from '../../../assets/images/img-tarjeta.png'
import img_tarjetaTropicalized from '../../../assets/images/img-tarjeta-tropicalized.png'
import Button from '../../atoms/button/button'
import { LOCALE, TROPICALIZED } from '../../../constants/activity-constants'
import Show from '../../../utils/show'

import './designCardSection.scss'

const DesignCardSection = () => {
  return (
    <div className="f-designCardSection-container">
      <div className="f-designCardSection-container__ancla" id="tarjetas" />
      <div className="f-designCardSection-wrapper">
        <section className="f-designCardSection-container__left">
          <figure>
            <img src={icon_1} alt="personaje nosotras navideño" />
            <h1>¡{TROPICALIZED ? 'Diseñá' : 'Diseña'} tu tarjeta navideña!</h1>
          </figure>
          <p>
            <Show valid={TROPICALIZED}>
              <b>
                ¡Elegí las tarjetas navideñas que más te gusten y sorprendé a
                los que más querés!{' '}
              </b>
              Para descargar cada tarjeta, deberás iniciar sesión en tu cuenta
              de NosotrasOnline y canjear 5 puntos, ¡es así de fácil!
              Descargalas ya
            </Show>
            <Show valid={!TROPICALIZED}>
              <b>
                ¡Elige las tarjetas navideñas que más te gusten, y sorprende a
                los que más quieres!{' '}
              </b>
              {LOCALE === 'es-BO' ? (
                <>
                  Para descargar cada tarjeta, deberás iniciar sesión en tu
                  cuenta de NosotrasOnline, ¡es así de fácil! Descárgalas ya.
                </>
              ) : (
                <>
                  Para descargar cada tarjeta, deberás iniciar sesión en tu
                  cuenta de NosotrasOnline y{' '}
                  {['es-PE', 'es-CL'].includes(LOCALE) ? 'canjear' : 'redimir'}{' '}
                  5 puntos, ¡es así de fácil! Descárgalas ya.
                </>
              )}
            </Show>
          </p>
        </section>
        <section className="f-designCardSection-container__right">
          <img
            src={TROPICALIZED ? img_tarjetaTropicalized : img_tarjeta}
            alt="personaje nosotras navideño"
          />
          {LOCALE !== 'es-BO' && (
            <span className="f-romboPuntosRedeem f-designCardSection-cover">
              <b className="f-romboPuntosRedeem__numero">5</b>
            </span>
          )}
          <Button
            text="¡Diseñar mi tarjeta!"
            onClick={() => {
              navigate('/designCard')
            }}
            metric={{
              event: 'Interacciones_Home_Navidad',
              category: 'Tarjetas',
            }}
          />
        </section>
      </div>
    </div>
  )
}

export default DesignCardSection
